import { GridToolbarExport } from "@mui/x-data-grid";
import styled from "@emotion/styled";

export default function ExportData({filename}) {
  const csvOptions = {
    fileName: filename,
  };
  const printOptions = {
    disableToolbarButton: true,
  };
  const CustomGridToolbarExport = styled(GridToolbarExport)(({ theme }) => ({
    color: theme.palette.text.primary,
  }));

  return (
    <CustomGridToolbarExport
      csvOptions={csvOptions}
      printOptions={printOptions}
    />
  );
}
